import { modules } from './modules'
/**
 * @fileOverview Clubhouse (/team/1/england) page parser functions
 */

/**
 * Rugby Clubhouse data parsers
 * @type {Object}
 */
export const clubhouse = {
  modules : modules,
  /**
   * [getMetaData updates meta data]
   * @param  {[type]} team     [team information]
   * @param  {[type]} location [location information]
   * @return {[type]}          [returns object]
   */
  getMetaData: function (team={}, location={}) {
    if(typeof team !== 'undefined') {
      if(team.hasOwnProperty('name') === true) {
        let team_name = team.name ? team.name : ''
        let team_logo = team.logoLarge ? team.logoLarge : ''
        return {
          title: `${team_name} News and Scores - ESPN`,
          description: `Get the latest ${team_name} news, scores, stats, standings, rumours, and more from ESPN.`,
          keywords: `${team_name}, rugby, rugby union, scores, news, schedule, highlights`,
          website: 'article',
          canonical: location.pathname,
          image: team_logo
        }
      }
    }
  }
}

export default clubhouse



/** WEBPACK FOOTER **
 ** ../app/lib/transform/parsers/rugby/clubhouse/index.js
 **/